import React, { useState } from 'react';
import Assets from './Assets';
import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronDown16 } from '@carbon/icons-react';
import Collapse from 'react-bootstrap/Collapse';
import './SubStages.css';
import funcTranslateHelper from '../../../../i18next/funcTranslateHelper';

const useStyles = makeStyles({
  card: {
    height: '100%',
    minHeight: '90px',
    backgroundColor: 'white',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10
  },
  content: {
    padding: '0px',
    height: '100%',
    '&:last-child': {
      paddingBottom: '20px'
    },
    position: 'relative'
  },
  bottom: {
    position: 'absolute',
    bottom: 0,
    height: 4,
    width: '100%'
  }
});

export default function SubStages ({ stages, assets, configFile }) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  return (
    <div>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography
            className={classes.title}
            color='textSecondary'
            style={{
              fontFamily: 'Roboto-Regular',
              fontWeight: '500',
              lineHeight: '22px',
              fontSize: '20px',
              color: 'rgba(0,0,0,0.87)',
              paddingTop: 19,
              paddingLeft: 18.4,
              marginBottom: 0,
              width: 148
            }}
            gutterBottom
          >
            {funcTranslateHelper(stages.name)}
            <button
              className='bx--accordion__arrow-custom'
              onClick={() => setOpen(!open)}
              aria-controls='example-collapse-text'
              aria-expanded={open}
            >
              <ChevronDown16 />
            </button>
          </Typography>
          <Typography
            className={classes.items}
            color='textSecondary'
            style={{
              fontFamily: 'Roboto-Regular',
              fontWeight: '500',
              fontSize: '14px',
              color: 'rgba(0,0,0,0.60)',
              letterSpacing: '0.25px',
              textAlign: 'left',
              lineHeight: '20px',
              paddingTop: 11,
              paddingLeft: 18.4,
              marginBottom: 0,
              width: 148
            }}
            gutterBottom
          >
            {assets
              ? assets.filter(assets => assets.currentStage === stages.id)
                .length + funcTranslateHelper('Items')
              : funcTranslateHelper('Items')}
          </Typography>
          <div className={classes.bottom} style={{ background: '#78A9FF' }} />
        </CardContent>
      </Card>
      <Collapse in={open}>
        {!stages.stages && (
          <Grid item>
            <div
              id='scroll'
              style={{
                // overflowY: 'scroll',
                overflowX: 'hidden',
                maxHeight: '280px',
                minHeight: '100px',
                marginTop: '5px'
              }}
            >
              {assets && (
                <Assets
                  origin={stages.id}
                  assets={assets}
                  stages={stages}
                  configFile={configFile}
                />
              )}
            </div>
          </Grid>
        )}
      </Collapse>
    </div>
  );
}
